import { render, staticRenderFns } from "./OrdersCalendar.vue?vue&type=template&id=4f6f5022&scoped=true&"
import script from "./OrdersCalendar.vue?vue&type=script&lang=js&"
export * from "./OrdersCalendar.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCalendar.vue?vue&type=style&index=0&id=4f6f5022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f5022",
  null
  
)

export default component.exports